/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component(
    'example-component',
    require('./components/ExampleComponent.vue').default
);

// Vue.use(VueLazyload);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    data: {
        activeItem: '',
        isShow: false,
    },
    methods: {
        isActive: function (menuItem) {
            return this.activeItem === menuItem;
        },
        setActive: function (menuItem) {
            this.activeItem = menuItem;
        },
    },
});

import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();
import 'animate.css';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import Fancybox from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox.css';
// -----

// ---------------
const selectLang = document.querySelector('.custom-select');
selectLang.addEventListener(
    'change',
    e => (window.location.href = e.target.value)
);

const options = {
    root: null,
    rootMargin: '0px 0px 0px 0px',
    threshold: 0.5,
};
const productsAreaGroup = document.querySelectorAll('.products__content');
const productsCallback = (entries, observer) => {
    entries.forEach(item => {
        if (item.isIntersecting) {
            // console.log(item);
            // console.log(`show ${item.target.dataset.name}`);
            productsBtn.forEach(ele => {
                const btnHref = ele.getAttribute('href').slice(1);
                if (item.target.dataset.name == btnHref) {
                    ele.classList.add('active');
                } else {
                    ele.classList.remove('active');
                }
            });
        }
    });
};
const productsObserver = new IntersectionObserver(productsCallback, options);
const haveProductsBtn =
    document.querySelector('.fixed_scroll_container') !== null;
let productsBtn;
if (haveProductsBtn) {
    productsBtn = document
        .querySelector('.fixed_scroll_container')
        .querySelectorAll('a');
    productsAreaGroup.forEach(function (item) {
        productsObserver.observe(item);
    });
    productsBtn.forEach(item => {
        item.addEventListener('click', function (e) {
            productsBtn.forEach(ele => ele.classList.remove('active'));
            this.classList.add('active');
        });
    });
}

const swiper = new Swiper('.home_swiper', {
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
    speed: 1000,
    autoplay: {
        delay: 4000,
    },
    pagination: {
        el: '.home_pagination',
        type: 'bullets',
        clickable: 'true',
    },
    on: {
        beforeInit: function () {
            const allBg = document.querySelectorAll('.home_bg');
            if (window.innerWidth > 768) {
                allBg.forEach(item => {
                    item.style.backgroundImage = `url('${item.dataset.pcbg}')`;
                });
            } else {
                allBg.forEach(item => {
                    item.style.backgroundImage = `url('${item.dataset.mbbg}')`;
                });
            }
        },
        init: function () {
            this.slides[this.activeIndex].classList.add('bg_animate');
            const animateArray =
                this.slides[this.activeIndex].querySelectorAll(
                    '.animate__animated'
                );
            animateArray.forEach((item, index) => {
                setTimeout(() => {
                    item.classList.add('animate__fadeInLeft');
                }, 1000 * (index / 2));
            });
        },
        slideChange: function () {
            const index = swiper.activeIndex;
            this.slides[index].classList.add('bg_animate');
            const animateArray =
                this.slides[index].querySelectorAll('.animate__animated');
            animateArray.forEach((item, index) => {
                setTimeout(() => {
                    item.classList.add('animate__fadeInLeft');
                }, 1000 * (index / 2));
            });

            //移除其他slide的背景效果跟文字效果
            const array = [...swiper.slides];
            array.splice(index, 1);
            array.forEach(element => {
                element
                    .querySelectorAll('.animate__animated')
                    .forEach(item =>
                        item.classList.remove('animate__fadeInLeft')
                    );
                setTimeout(() => {
                    element.classList.remove('bg_animate');
                }, 1000);
            });
        },
    },
});

const swiperHomeProducts = new Swiper('.products_swiper', {
    speed: 1000,
    slidesPerView: 1.5,
    spaceBetween: 30,
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        900: {
            slidesPerView: 3.5,
            spaceBetween: 20,
        },
        1050: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
        1200: {
            slidesPerView: 4.5,
            spaceBetween: 30,
        },
        1400: {
            slidesPerView: 5.5,
            spaceBetween: 30,
        },
    },
    scrollbar: {
        el: '.products_scrollbar',
        draggable: true,
        // hide: true,
    },
    navigation: {
        nextEl: '.products_next',
        prevEl: '.products_prev',
    },
});

const swiperPageProducts = new Swiper('.products_page_swiper', {
    slidesPerView: 2,
    speed: 1000,
    spaceBetween: 30,
    breakpoints: {
        768: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        900: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
        1200: {
            slidesPerView: 5,
            spaceBetween: 30,
        },
    },
    scrollbar: {
        el: '.products_scrollbar',
        draggable: true,
        // hide: true,
    },
    navigation: {
        nextEl: '.products_next',
        prevEl: '.products_prev',
    },
});

const swiperHomeSolutions = new Swiper('.solutions_swiper', {
    speed: 1000,
    slidesPerView: 1.5,
    spaceBetween: 15,
    centeredSlides: true,
    loop: true,
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        900: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
    },
    scrollbar: {
        el: '.solutions_scrollbar',
        draggable: true,
        // hide: true,
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
        clickable: true,
    },
    navigation: {
        nextEl: '.solutions_button_next',
        prevEl: '.solutions_button_prev',
    },
});

const swiperHomeNews = new Swiper('.news_swiper', {
    speed: 1000,
    slidesPerView: 1.2,
    spaceBetween: 15,
    breakpoints: {
        650: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 2.5,
            spaceBetween: 20,
        },
        900: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        1100: {
            slidesPerView: 3.5,
            spaceBetween: 30,
        },
        1400: {
            slidesPerView: 4.4,
            spaceBetween: 30,
        },
    },
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        // hide: true,
    },
    navigation: {
        nextEl: '.news_next',
        prevEl: '.news_prev',
    },
});

const galleryThumbs = new Swiper('.gallery-thumbs', {
    speed: 1000,
    slidesPerView: 6,
});
const galleryTop = new Swiper('.gallery-top', {
    spaceBetween: 10,
    thumbs: {
        swiper: galleryThumbs,
    },
    on: {
        slideChange: function () {
            let activeIndex = this.activeIndex + 1;
            let activeSlide = document.querySelector(
                `.gallery-thumbs .swiper-slide:nth-child(${activeIndex})`
            );
            let nextSlide = document.querySelector(
                `.gallery-thumbs .swiper-slide:nth-child(${activeIndex + 1})`
            );
            let prevSlide = document.querySelector(
                `.gallery-thumbs .swiper-slide:nth-child(${activeIndex - 1})`
            );
            if (
                nextSlide &&
                !nextSlide.classList.contains('swiper-slide-visible')
            ) {
                this.thumbs.swiper.slideNext();
            } else if (
                prevSlide &&
                !prevSlide.classList.contains('swiper-slide-visible')
            ) {
                this.thumbs.swiper.slidePrev();
            }
        },
    },
});
